import { useState, useCallback } from 'react';
import { rasService } from '../services/rasService';
import { UnprocessedRecord, QueryParams, ApiResponse } from '../types/api';
import { useToast } from './useToast';

export const useUnprocessed = () => {
  const [data, setData] = useState<UnprocessedRecord[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [count, setCount] = useState<number>(0);
  const { showToast } = useToast();

  const queryUnprocessed = useCallback(async (queryParams: QueryParams = {}) => {
    setLoading(true);
    setError(null);
    
    try {
      const response: ApiResponse<UnprocessedRecord[]> = await rasService.queryUnprocessed(queryParams);
      
      if (response.error) {
        throw new Error(response.error);
      }
      
      setData(response.data || []);
      setCount(response.count || 0);
      showToast(`Found ${response.count || 0} unprocessed races`, 'success');
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to query unprocessed races';
      setError(errorMessage);
      setData([]);
      setCount(0);
      showToast(errorMessage, 'error');
    } finally {
      setLoading(false);
    }
  }, [showToast]);

  const clearResults = useCallback(() => {
    setData([]);
    setCount(0);
    setError(null);
  }, []);

  return {
    data,
    loading,
    error,
    count,
    queryUnprocessed,
    clearResults,
  };
};